// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Rye&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url('https://fonts.googleapis.com/css2?family=MedievalSharp&family=Rye&display=swap'); */
:root{
  --prussian: #182A40;
  --steel: #5A7D9D;
  --pearl: #EAE0CC;
  --pale: #C9ADA1;
  --sage: #A0A083;
  --delete: #724444;

}


/* 1. Use a more-intuitive box-sizing model */
*, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0
  }
  
  
  body {
    
    -webkit-font-smoothing: antialiased;

    font-family: 'Montserrat';
    
    font-size: 62.5%;

    background-color: var(--prussian);

  }
  
  /* 5. Improve media defaults */
  img, picture, video, canvas, svg {
    display: block;
    max-width: 100%;
  }
  
  /* 6. Inherit fonts for form controls */
  input, button, textarea, select {
    font: inherit;
  }
  
  /* 7. Avoid text overflows */
  p, h1, h2, h3, h4, h5, h6 {
    overflow-wrap: break-word;
  }
  
  /* 8. Improve line wrapping */
  p {
    text-wrap: pretty;
  }
  h1, h2, h3, h4, h5, h6 {
    text-wrap: balance;
  }
  
  /*
    9. Create a root stacking context
  */
  #root, #__next {
    isolation: isolate;
  }
/* //////////////////////////////////GLOBALS////////////////////////////////////////// */
svg{
  transition: all 0.1s ease-in;
}
button{
  user-select: none;
}
button:hover{
  filter: brightness(2);
}
button:active{
  transform: scale(0.98);
}
Dialog{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); 

  width: 100dvw;
  height: 100dvh;
  max-width: 100dvw;
  max-height: 100dvh;

  border: none;
  outline: none;
  animation: popIn 0.1s ease-in;
  
  background-color: transparent;
}

dialog::backdrop {
  background: #0000009f;
}
/* //////////////////////////////////////////////// */
header{
  display: flex;
  justify-content: center;

  padding: 1rem 0;

  user-select: none;
}
header > div{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

}
header h1{
  color: var(--steel);
  font-size: 4rem;
  font-weight: 900;
}
header img{
  align-self: center;
  height: 200px;
  width: auto;
}

header svg{
  height: 4rem;
  width: 4rem;

  color: var(--steel);

  margin-top: 1rem;

  cursor: pointer;
}

header svg:hover{
  animation: emphacise 0.2s ease forwards ;
}

@keyframes emphacise {
  0% {color: var(--steel);}
  100% {color: var(--sage);}
}

header svg:not(:hover) {
  animation: deEmphrasis 0.2s ease forwards ;
}

@keyframes deEmphrasis {
  0% {color: var(--sage);}
  100% {color: var(--steel);}
}

header > div > div {
  display: flex;
  gap: 20px;
}

header > div > div > button{

  font-size: 1.5rem;
  color: var(--prussian);

  margin-top: 1.5rem;
  background-color: var(--steel);

  /* border-radius: 15px; */

  padding: 10px;

  user-select: none;

  cursor: pointer;

  /* box-shadow: inset var(--sage) 3px 3px 4px 1px, inset var(--prussian) -2px -2px 6px 0px; */

  font-weight: 900;
  border-color: var(--steel);

  border: none;
  /* border-radius: 50%;   */
  height: 150px;
  width: 150px;

  transition: all 0.1s ease-in;
}

header > div > div > button:nth-child(1){
/* border-radius: 50% 0% 0% 50% / 50% 50% 50% 50% ; */
border-radius: 50%;
box-shadow: inset var(--sage) 3px 3px 4px 1px, inset var(--prussian) -2px -2px 6px 0px;
}
header > div > div > button:nth-child(2){
/* border-radius: 0% 50% 50% 0% / 0% 50% 50% 0% ; */
border-radius: 50%;
box-shadow: inset var(--sage) -3px 3px 4px 1px, inset var(--prussian) 2px -2px 6px 0px;
}

button{
  transition: all 0.1s ease-in;
}


main{
  display: flex;
  justify-content: center;
}

.card-grid{
  justify-self: center;
  display: grid;
  justify-items: center;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));

  gap: 15px;

  padding-top: 1rem;

  min-width: 400px;
  max-width: 1300px;

}

.card{
  position:relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  
  width: 400px;
  height: 200px;

  background-color: var(--sage);

  border-radius: 15px;

  padding: 10px;

  user-select: none;

  cursor: pointer;

  /* border: 5px double var(--prussian); */

  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;

  font-weight: 600;

  transition: all 0.1s ease-in;

  
}
.card:hover{
  filter:brightness(1.5);
}

.card h2{
  font-size: 2rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;


  width: 350px;
  text-align: center;
}


.card p:nth-child(2){
  font-size: 1.5rem;
  font-weight: 500;

  width: 350px;
  text-overflow: ellipsis;
  overflow: hidden;
  text-wrap: wrap;

  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  
}
.card p:nth-child(3){
  font-size: 1.5rem;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;


}

.card div:nth-child(4){
  position: absolute;
  color: var(--delete);
  bottom: 15px;
  right: 15px;
  transition: all 0.1s ease-in;
}
.card div:nth-child(4):hover{
  transform: scale(1.5);
}

.card div:nth-child(5){
  position: absolute;
  color: var(--pearl);
  bottom: 15px;
  right: 40px;
}

.all-taskList{
  display: none;
  flex-direction: column;

  border-radius: 10px;
  padding: 10px;

  background-color: var(--sage);
  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;


}
/* ////////////////////////////////////////////////////////////////////////////// */
/* ////////////////////////////////////////////////////////////////////////////// */


@keyframes popIn {
  0% {opacity: 0;}
  100% {opacity: 1;}

  
}

.new-project{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  position: absolute;
  left: 50%;
  top:50%;
  transform: translate(-50%, -50%); 

  padding: 2rem;

  /* border: 5px double var(--prussian); */

  border-radius: 15px;

  background-color: var(--sage);

  /* max-width: 600px; */
  /* min-width: 400px; */
  
  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;

}

.new-project div{
  display: flex;
  gap: 2rem;
  /* flex-direction: column; */

}

.new-project h2{
  font-size: 3rem;
  font-weight:900;
  margin-bottom: 1rem;
  text-align: center;
}

.new-project div label{
  font-size: 2rem;
  font-weight: 500;
  border-radius: 15px;
  width: 11rem;
}

.new-project div label, .new-project h2{
  user-select: none;

}

.new-project input, .new-project textarea{
  width: 17rem;
  font-size: 2rem;
  text-indent: 0.5rem;
  border-radius: 15px;
  padding: 5px 0;

  background-color: var(--pearl);

}



.new-project div:nth-child(5){
  display: flex;
  justify-content: center;  

  margin-top: 2rem;
  margin-bottom: 2rem;
}

.new-project button{
  font-size: 2rem;
  font-weight: 900;

  border-radius: 15px;
  padding: 0.5rem 2rem;

  border:none;
  outline: none;
}

.new-project button:nth-child(1){
  background-color: var(--steel);
  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;
}
.new-project button:nth-child(2){
  background-color: var(--sage);
  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;
}

.projectContent{

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;

  position: absolute;
  left: 50%;
  top:50%;
  transform: translate(-50%, -50%); 

  padding: 3rem 1.5rem;

  border-radius: 15px;

  background-color: var(--sage);

  min-width: 400px;
  min-height: 400px;

  min-width: 400px;

  animation: popIn 0.1s ease-in;

  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;


}

.projectContent > h3{
  font-size: 2.5rem;
  user-select: none;
  text-align: center;
}

.projectContent > svg:nth-child(2){
  position: absolute;
  right: 10px;
  top: 10px;

  width: 40px;
  height: 40px;
  color: var(--prussian);
}

/* .projectContent > svg:last-child{
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 20px;

  width: 70px;
  height: 70px;
  color: var(--prussian);
} */
.projectContent > button:last-child{
  font-size: 1.2rem;
  color: var(--prussian);

  background-color: var(--steel);

  user-select: none;

  cursor: pointer;

  box-shadow: inset var(--pearl) 3px 3px 4px 1px, inset var(--prussian) -2px -2px 6px 0px;

  font-weight: 900;

  border: none;
  border-radius: 50%;
  height: 100px;
  width: 100px;

  transition: all 0.1s ease-in;
}
.projectContent > svg:hover{
  color: var(--pearl);
  cursor: pointer;
  
}

.taskList{
  display: none;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  /* width: 100%; */
  /* max-width: 800px; */


  margin-bottom: 1rem;

  user-select: none;

}
.taskList > div{
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 1.5rem;
  font-weight: 500;
  
  width: 600px;
  min-height: 50px;

  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;
  border-radius: 20px;
  padding: 0.5rem 0;

  cursor: pointer;

  transition: all 0.1s ease-in;


}

.taskList > div > div p:nth-child(2){
  width: 370px;
  text-wrap: wrap;
}
.taskList > div > div p:nth-child(3){
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;

  color: var(--prussian);

  /* justify-self: end; */
  /* width: 400px; */
  text-wrap: nowrap;
  /* padding: 0 0.5px; */

}

.taskList > div > div{
  display: flex;
  gap: 5px;
}
.taskList > div > div:nth-child(1){
  width: 85%;
}

.taskList > div > div:nth-child(1) >div:nth-child(1){
  display: flex;
  align-items: center;
  margin-left: 10px;

  width: 24px;
  transition: all 0.1s ease-in;
}
.taskList > div > div:nth-child(1) >div:nth-child(1):hover{
  transform: scale(1.3);
}

.taskList > div > div:nth-child(2){
  width: 80px;

}
.taskList > div > div:nth-child(2) div:nth-child(1){
  color: var(--prussian);
  transition: all 0.1s ease-in;
}

.taskList > div > div:nth-child(2) div:nth-child(2){
  color: var(--delete);

  transition: all 0.1s ease-in;

}

.taskList > div > div:nth-child(2) div:hover{
  transform: scale(1.3);

}

.taskList >div:not(form):hover{
  filter: brightness(1.3);
  text-shadow: 1px 1px 2px var(--pearl);
}


.editTask {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: row;

  font-size: 1.5rem;

  height: 40px;
  margin: 0;
  padding: 0;
  width: 100%;
}
.editTask > input:nth-child(1){
  width: 75%;
  /* height: 50px; */
  font-size: 1.5rem;
  text-indent: 0.5rem;
  border-radius: 10px;
  
}
.editTask > button{
  display: flex;
  background-color: transparent;
  border: none;

}



.projectContent .taskList > form{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  margin-top: 1rem;

  animation: popIn 0.1s ease-in;

  /* border: 1px solid var(--prussian); */
  /* box-shadow: 0 0 5px 1px var(--prussian); */
  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;
  border-radius: 10px;
  padding: 1rem 0.5rem;

}
@keyframes popIn {
  0% {opacity: 0;}
  100%{ opacity: 1;}
  
}
.projectContent .taskList > form > div:nth-child(1){
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.projectContent .taskList > form > div >input:nth-child(1), .projectContent .taskList > form > div >input:nth-child(2){
  width: 90%;
  align-self: center;
  font-size: 2rem;
  text-indent: 0.5rem;

  border-radius: 15px;
  padding: 5px 0;

  background-color: var(--pearl);

  
}
.projectContent .taskList > form > div:nth-child(1) >input:first-child::placeholder{
  text-align: center;
}
.projectContent .taskList > form > div:nth-child(1) >input:nth-child(2){
  
  text-align: center;
}

.projectContent .taskList > form > div:nth-child(2){
  display: flex;
  gap: 25px;
  padding: 5px 20px;

  /* margin-bottom: 3rem; */
}

.projectContent .taskList >form > div:nth-child(2){

  border-radius: 10px;
}

.projectContent .taskList > form button {
  border-radius: 50%;
  border-color: transparent;
  background-color: transparent;

  cursor: pointer;
  
  
}
/* .projectContent .taskList > form button:nth-child(1) {
  
box-shadow:  0 0 11px 5px var(--sage), var(--prussian) 3px 3px 6px 5px,  var(--pearl) -2px -2px 6px 8px;
background-color: var(--pr);
}
.projectContent .taskList > form button:nth-child(2) {
  box-shadow:  0 0 11px 5px var(--sage), var(--prussian) 3px 3px 6px 5px,  var(--pearl) -2px -2px 6px 8px;
} */



.projectContent .taskList > form button svg{
  height: 50px;
  width: 50px;
}

.projectContent .taskList > form button:nth-child(1) > svg{
  color: var(--prussian);
}
.projectContent .taskList > form button:nth-child(2) > svg{
  color: var(--pearl);
  
}


.priorityRadio{
  display: flex;
  align-items: center;
  justify-content: space-between;

  align-self: center;
  /* grid-template-areas:  "title title title"
                        "low mid high"; */

  width: 90%;
  /* background-color: red; */
}
.priorityRadio h4:nth-child(1){
  /* grid-area: title; */
  display: flex;
  align-items: center;

  font-size: 2rem;
  font-weight: 500;

  padding-bottom: 7px;
}

.priorityRadio > div{
  display: flex;
  border-radius: 50px;
}
.priorityRadio > div > input{
  cursor: pointer;
  height: 40px;
  width: 40px;
  align-self: none;
}

.priorityRadio > div:nth-child(2){

  box-shadow:  0 0 11px 5px yellow, var(--prussian) 3px 3px 6px 5px,  var(--pearl) -2px -2px 6px 8px;;
}

.priorityRadio div:nth-child(3){
  box-shadow:  0 0 11px 5px orange, var(--prussian) 3px 3px 6px 5px,  var(--pearl) -2px -2px 6px 8px;
}
.priorityRadio div:nth-child(4){
  box-shadow:  0 0 11px 5px red ,var(--prussian) 3px 3px 6px 5px,  var(--pearl) -2px -2px 6px 8px;
  
}

/* ////////////////////////////////////////////////////////////////////////////// */
/* ////////////////////////////////////////////////////////////////////////////// */
@media screen and  (max-width: 600px){
  /* .projectContent{
    padding: 0rem;
  } */
  .new-project div{
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 5px;
    margin-bottom: 10px;
  }

  .new-project div:nth-child(5){
    gap: 10px;

    margin-top: 1rem;
    margin-bottom: 10px;

    flex-direction: column;
    justify-content: center;  
    align-items: center;
  }

  .taskList{
    
    max-width: 400px;
    

  }
  .taskList > div{
    width: 400px;
  }
  .taskList p{
    
    width: 255px;
    text-wrap: wrap;
  
    
  
  }
}
/* ////////////////////////////////////////////////////////////////////////////// */
/* ////////////////////////////////////////////////////////////////////////////// */`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,mGAAmG;AAGnG;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;;AAEnB;;;AAGA,6CAA6C;AAC7C;IACI,sBAAsB;IACtB,SAAS;IACT;EACF;;;EAGA;;IAEE,mCAAmC;;IAEnC,yBAAyB;;IAEzB,gBAAgB;;IAEhB,iCAAiC;;EAEnC;;EAEA,8BAA8B;EAC9B;IACE,cAAc;IACd,eAAe;EACjB;;EAEA,uCAAuC;EACvC;IACE,aAAa;EACf;;EAEA,4BAA4B;EAC5B;IACE,yBAAyB;EAC3B;;EAEA,6BAA6B;EAC7B;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;;EAEA;;GAEC;EACD;IACE,kBAAkB;EACpB;AACF,wFAAwF;AACxF;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;;EAEhC,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;;EAElB,YAAY;EACZ,aAAa;EACb,6BAA6B;;EAE7B,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;AACA,qDAAqD;AACrD;EACE,aAAa;EACb,uBAAuB;;EAEvB,eAAe;;EAEf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;;AAExB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;;EAEX,mBAAmB;;EAEnB,gBAAgB;;EAEhB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,IAAI,mBAAmB,CAAC;EACxB,MAAM,kBAAkB,CAAC;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,IAAI,kBAAkB,CAAC;EACvB,MAAM,mBAAmB,CAAC;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;;EAEtB,kBAAkB;EAClB,8BAA8B;;EAE9B,yBAAyB;;EAEzB,aAAa;;EAEb,iBAAiB;;EAEjB,eAAe;;EAEf,4FAA4F;;EAE5F,gBAAgB;EAChB,0BAA0B;;EAE1B,YAAY;EACZ,0BAA0B;EAC1B,aAAa;EACb,YAAY;;EAEZ,4BAA4B;AAC9B;;AAEA;AACA,qDAAqD;AACrD,kBAAkB;AAClB,sFAAsF;AACtF;AACA;AACA,mDAAmD;AACnD,kBAAkB;AAClB,sFAAsF;AACtF;;AAEA;EACE,4BAA4B;AAC9B;;;AAGA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,2DAA2D;;EAE3D,SAAS;;EAET,iBAAiB;;EAEjB,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;;EAEnB,YAAY;EACZ,aAAa;;EAEb,6BAA6B;;EAE7B,mBAAmB;;EAEnB,aAAa;;EAEb,iBAAiB;;EAEjB,eAAe;;EAEf,wCAAwC;;EAExC,uFAAuF;;EAEvF,gBAAgB;;EAEhB,4BAA4B;;;AAG9B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;;;EAGhB,YAAY;EACZ,kBAAkB;AACpB;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;;EAEhB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;;EAEf,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;;AAE9B;AACA;EACE,iBAAiB;;EAEjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;;;AAGlB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB,mBAAmB;EACnB,aAAa;;EAEb,6BAA6B;EAC7B,uFAAuF;;;AAGzF;AACA,mFAAmF;AACnF,mFAAmF;;;AAGnF;EACE,IAAI,UAAU,CAAC;EACf,MAAM,UAAU,CAAC;;;AAGnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;;EAET,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gCAAgC;;EAEhC,aAAa;;EAEb,wCAAwC;;EAExC,mBAAmB;;EAEnB,6BAA6B;;EAE7B,sBAAsB;EACtB,sBAAsB;;EAEtB,uFAAuF;;AAEzF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4BAA4B;;AAE9B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;;AAEnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;;EAEd,8BAA8B;;AAEhC;;;;AAIA;EACE,aAAa;EACb,uBAAuB;;EAEvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;;EAEhB,mBAAmB;EACnB,oBAAoB;;EAEpB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,uFAAuF;AACzF;AACA;EACE,6BAA6B;EAC7B,uFAAuF;AACzF;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;;EAET,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gCAAgC;;EAEhC,oBAAoB;;EAEpB,mBAAmB;;EAEnB,6BAA6B;;EAE7B,gBAAgB;EAChB,iBAAiB;;EAEjB,gBAAgB;;EAEhB,6BAA6B;;EAE7B,uFAAuF;;;AAGzF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;;EAET,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;;;;;;;;GASG;AACH;EACE,iBAAiB;EACjB,sBAAsB;;EAEtB,8BAA8B;;EAE9B,iBAAiB;;EAEjB,eAAe;;EAEf,uFAAuF;;EAEvF,gBAAgB;;EAEhB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;;EAEZ,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,eAAe;;AAEjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,sBAAsB;;;EAGtB,mBAAmB;;EAEnB,iBAAiB;;AAEnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB,iBAAiB;EACjB,gBAAgB;;EAEhB,YAAY;EACZ,gBAAgB;;EAEhB,uFAAuF;EACvF,mBAAmB;EACnB,iBAAiB;;EAEjB,eAAe;;EAEf,4BAA4B;;;AAG9B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,sBAAsB;;EAEtB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;;AAExB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;;EAEjB,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;;AAEb;AACA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;;EAEpB,4BAA4B;;AAE9B;;AAEA;EACE,qBAAqB;;AAEvB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;;AAGA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;;EAEnB,iBAAiB;;EAEjB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;AACb;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;;AAErB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,YAAY;;AAEd;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;;EAET,gBAAgB;;EAEhB,6BAA6B;;EAE7B,uCAAuC;EACvC,6CAA6C;EAC7C,uFAAuF;EACvF,mBAAmB;EACnB,oBAAoB;;AAEtB;AACA;EACE,IAAI,UAAU,CAAC;EACf,MAAM,UAAU,CAAC;;AAEnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,mBAAmB;;EAEnB,mBAAmB;EACnB,cAAc;;EAEd,8BAA8B;;;AAGhC;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;;EAEjB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;;EAE7B,eAAe;;;AAGjB;AACA;;;;;;;GAOG;;;;AAIH;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;;AAErB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,kBAAkB;EAClB;yCACuC;;EAEvC,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;;EAEnB,eAAe;EACf,gBAAgB;;EAEhB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,kGAAkG;AACpG;;AAEA;EACE,kGAAkG;AACpG;AACA;EACE,+FAA+F;;AAEjG;;AAEA,mFAAmF;AACnF,mFAAmF;AACnF;EACE;;KAEG;EACH;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,SAAS;;IAET,gBAAgB;IAChB,mBAAmB;;IAEnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;;;EAGlB;EACA;IACE,YAAY;EACd;EACA;;IAEE,YAAY;IACZ,eAAe;;;;EAIjB;AACF;AACA,mFAAmF;AACnF,mFAAmF","sourcesContent":["/* @import url('https://fonts.googleapis.com/css2?family=MedievalSharp&family=Rye&display=swap'); */\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Rye&display=swap');\r\n:root{\r\n  --prussian: #182A40;\r\n  --steel: #5A7D9D;\r\n  --pearl: #EAE0CC;\r\n  --pale: #C9ADA1;\r\n  --sage: #A0A083;\r\n  --delete: #724444;\r\n\r\n}\r\n\r\n\r\n/* 1. Use a more-intuitive box-sizing model */\r\n*, *::before, *::after {\r\n    box-sizing: border-box;\r\n    margin: 0;\r\n    padding: 0\r\n  }\r\n  \r\n  \r\n  body {\r\n    \r\n    -webkit-font-smoothing: antialiased;\r\n\r\n    font-family: 'Montserrat';\r\n    \r\n    font-size: 62.5%;\r\n\r\n    background-color: var(--prussian);\r\n\r\n  }\r\n  \r\n  /* 5. Improve media defaults */\r\n  img, picture, video, canvas, svg {\r\n    display: block;\r\n    max-width: 100%;\r\n  }\r\n  \r\n  /* 6. Inherit fonts for form controls */\r\n  input, button, textarea, select {\r\n    font: inherit;\r\n  }\r\n  \r\n  /* 7. Avoid text overflows */\r\n  p, h1, h2, h3, h4, h5, h6 {\r\n    overflow-wrap: break-word;\r\n  }\r\n  \r\n  /* 8. Improve line wrapping */\r\n  p {\r\n    text-wrap: pretty;\r\n  }\r\n  h1, h2, h3, h4, h5, h6 {\r\n    text-wrap: balance;\r\n  }\r\n  \r\n  /*\r\n    9. Create a root stacking context\r\n  */\r\n  #root, #__next {\r\n    isolation: isolate;\r\n  }\r\n/* //////////////////////////////////GLOBALS////////////////////////////////////////// */\r\nsvg{\r\n  transition: all 0.1s ease-in;\r\n}\r\nbutton{\r\n  user-select: none;\r\n}\r\nbutton:hover{\r\n  filter: brightness(2);\r\n}\r\nbutton:active{\r\n  transform: scale(0.98);\r\n}\r\nDialog{\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%); \r\n\r\n  width: 100dvw;\r\n  height: 100dvh;\r\n  max-width: 100dvw;\r\n  max-height: 100dvh;\r\n\r\n  border: none;\r\n  outline: none;\r\n  animation: popIn 0.1s ease-in;\r\n  \r\n  background-color: transparent;\r\n}\r\n\r\ndialog::backdrop {\r\n  background: #0000009f;\r\n}\r\n/* //////////////////////////////////////////////// */\r\nheader{\r\n  display: flex;\r\n  justify-content: center;\r\n\r\n  padding: 1rem 0;\r\n\r\n  user-select: none;\r\n}\r\nheader > div{\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n\r\n}\r\nheader h1{\r\n  color: var(--steel);\r\n  font-size: 4rem;\r\n  font-weight: 900;\r\n}\r\nheader img{\r\n  align-self: center;\r\n  height: 200px;\r\n  width: auto;\r\n}\r\n\r\nheader svg{\r\n  height: 4rem;\r\n  width: 4rem;\r\n\r\n  color: var(--steel);\r\n\r\n  margin-top: 1rem;\r\n\r\n  cursor: pointer;\r\n}\r\n\r\nheader svg:hover{\r\n  animation: emphacise 0.2s ease forwards ;\r\n}\r\n\r\n@keyframes emphacise {\r\n  0% {color: var(--steel);}\r\n  100% {color: var(--sage);}\r\n}\r\n\r\nheader svg:not(:hover) {\r\n  animation: deEmphrasis 0.2s ease forwards ;\r\n}\r\n\r\n@keyframes deEmphrasis {\r\n  0% {color: var(--sage);}\r\n  100% {color: var(--steel);}\r\n}\r\n\r\nheader > div > div {\r\n  display: flex;\r\n  gap: 20px;\r\n}\r\n\r\nheader > div > div > button{\r\n\r\n  font-size: 1.5rem;\r\n  color: var(--prussian);\r\n\r\n  margin-top: 1.5rem;\r\n  background-color: var(--steel);\r\n\r\n  /* border-radius: 15px; */\r\n\r\n  padding: 10px;\r\n\r\n  user-select: none;\r\n\r\n  cursor: pointer;\r\n\r\n  /* box-shadow: inset var(--sage) 3px 3px 4px 1px, inset var(--prussian) -2px -2px 6px 0px; */\r\n\r\n  font-weight: 900;\r\n  border-color: var(--steel);\r\n\r\n  border: none;\r\n  /* border-radius: 50%;   */\r\n  height: 150px;\r\n  width: 150px;\r\n\r\n  transition: all 0.1s ease-in;\r\n}\r\n\r\nheader > div > div > button:nth-child(1){\r\n/* border-radius: 50% 0% 0% 50% / 50% 50% 50% 50% ; */\r\nborder-radius: 50%;\r\nbox-shadow: inset var(--sage) 3px 3px 4px 1px, inset var(--prussian) -2px -2px 6px 0px;\r\n}\r\nheader > div > div > button:nth-child(2){\r\n/* border-radius: 0% 50% 50% 0% / 0% 50% 50% 0% ; */\r\nborder-radius: 50%;\r\nbox-shadow: inset var(--sage) -3px 3px 4px 1px, inset var(--prussian) 2px -2px 6px 0px;\r\n}\r\n\r\nbutton{\r\n  transition: all 0.1s ease-in;\r\n}\r\n\r\n\r\nmain{\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.card-grid{\r\n  justify-self: center;\r\n  display: grid;\r\n  justify-items: center;\r\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\r\n\r\n  gap: 15px;\r\n\r\n  padding-top: 1rem;\r\n\r\n  min-width: 400px;\r\n  max-width: 1300px;\r\n\r\n}\r\n\r\n.card{\r\n  position:relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  \r\n  width: 400px;\r\n  height: 200px;\r\n\r\n  background-color: var(--sage);\r\n\r\n  border-radius: 15px;\r\n\r\n  padding: 10px;\r\n\r\n  user-select: none;\r\n\r\n  cursor: pointer;\r\n\r\n  /* border: 5px double var(--prussian); */\r\n\r\n  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;\r\n\r\n  font-weight: 600;\r\n\r\n  transition: all 0.1s ease-in;\r\n\r\n  \r\n}\r\n.card:hover{\r\n  filter:brightness(1.5);\r\n}\r\n\r\n.card h2{\r\n  font-size: 2rem;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n\r\n\r\n  width: 350px;\r\n  text-align: center;\r\n}\r\n\r\n\r\n.card p:nth-child(2){\r\n  font-size: 1.5rem;\r\n  font-weight: 500;\r\n\r\n  width: 350px;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  text-wrap: wrap;\r\n\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 3;\r\n  line-clamp: 3;\r\n  -webkit-box-orient: vertical;\r\n  \r\n}\r\n.card p:nth-child(3){\r\n  font-size: 1.5rem;\r\n\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n\r\n\r\n}\r\n\r\n.card div:nth-child(4){\r\n  position: absolute;\r\n  color: var(--delete);\r\n  bottom: 15px;\r\n  right: 15px;\r\n  transition: all 0.1s ease-in;\r\n}\r\n.card div:nth-child(4):hover{\r\n  transform: scale(1.5);\r\n}\r\n\r\n.card div:nth-child(5){\r\n  position: absolute;\r\n  color: var(--pearl);\r\n  bottom: 15px;\r\n  right: 40px;\r\n}\r\n\r\n.all-taskList{\r\n  display: none;\r\n  flex-direction: column;\r\n\r\n  border-radius: 10px;\r\n  padding: 10px;\r\n\r\n  background-color: var(--sage);\r\n  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;\r\n\r\n\r\n}\r\n/* ////////////////////////////////////////////////////////////////////////////// */\r\n/* ////////////////////////////////////////////////////////////////////////////// */\r\n\r\n\r\n@keyframes popIn {\r\n  0% {opacity: 0;}\r\n  100% {opacity: 1;}\r\n\r\n  \r\n}\r\n\r\n.new-project{\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 10px;\r\n\r\n  position: absolute;\r\n  left: 50%;\r\n  top:50%;\r\n  transform: translate(-50%, -50%); \r\n\r\n  padding: 2rem;\r\n\r\n  /* border: 5px double var(--prussian); */\r\n\r\n  border-radius: 15px;\r\n\r\n  background-color: var(--sage);\r\n\r\n  /* max-width: 600px; */\r\n  /* min-width: 400px; */\r\n  \r\n  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;\r\n\r\n}\r\n\r\n.new-project div{\r\n  display: flex;\r\n  gap: 2rem;\r\n  /* flex-direction: column; */\r\n\r\n}\r\n\r\n.new-project h2{\r\n  font-size: 3rem;\r\n  font-weight:900;\r\n  margin-bottom: 1rem;\r\n  text-align: center;\r\n}\r\n\r\n.new-project div label{\r\n  font-size: 2rem;\r\n  font-weight: 500;\r\n  border-radius: 15px;\r\n  width: 11rem;\r\n}\r\n\r\n.new-project div label, .new-project h2{\r\n  user-select: none;\r\n\r\n}\r\n\r\n.new-project input, .new-project textarea{\r\n  width: 17rem;\r\n  font-size: 2rem;\r\n  text-indent: 0.5rem;\r\n  border-radius: 15px;\r\n  padding: 5px 0;\r\n\r\n  background-color: var(--pearl);\r\n\r\n}\r\n\r\n\r\n\r\n.new-project div:nth-child(5){\r\n  display: flex;\r\n  justify-content: center;  \r\n\r\n  margin-top: 2rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.new-project button{\r\n  font-size: 2rem;\r\n  font-weight: 900;\r\n\r\n  border-radius: 15px;\r\n  padding: 0.5rem 2rem;\r\n\r\n  border:none;\r\n  outline: none;\r\n}\r\n\r\n.new-project button:nth-child(1){\r\n  background-color: var(--steel);\r\n  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;\r\n}\r\n.new-project button:nth-child(2){\r\n  background-color: var(--sage);\r\n  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;\r\n}\r\n\r\n.projectContent{\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 2rem;\r\n\r\n  position: absolute;\r\n  left: 50%;\r\n  top:50%;\r\n  transform: translate(-50%, -50%); \r\n\r\n  padding: 3rem 1.5rem;\r\n\r\n  border-radius: 15px;\r\n\r\n  background-color: var(--sage);\r\n\r\n  min-width: 400px;\r\n  min-height: 400px;\r\n\r\n  min-width: 400px;\r\n\r\n  animation: popIn 0.1s ease-in;\r\n\r\n  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;\r\n\r\n\r\n}\r\n\r\n.projectContent > h3{\r\n  font-size: 2.5rem;\r\n  user-select: none;\r\n  text-align: center;\r\n}\r\n\r\n.projectContent > svg:nth-child(2){\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 10px;\r\n\r\n  width: 40px;\r\n  height: 40px;\r\n  color: var(--prussian);\r\n}\r\n\r\n/* .projectContent > svg:last-child{\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translate(-50%);\r\n  bottom: 20px;\r\n\r\n  width: 70px;\r\n  height: 70px;\r\n  color: var(--prussian);\r\n} */\r\n.projectContent > button:last-child{\r\n  font-size: 1.2rem;\r\n  color: var(--prussian);\r\n\r\n  background-color: var(--steel);\r\n\r\n  user-select: none;\r\n\r\n  cursor: pointer;\r\n\r\n  box-shadow: inset var(--pearl) 3px 3px 4px 1px, inset var(--prussian) -2px -2px 6px 0px;\r\n\r\n  font-weight: 900;\r\n\r\n  border: none;\r\n  border-radius: 50%;\r\n  height: 100px;\r\n  width: 100px;\r\n\r\n  transition: all 0.1s ease-in;\r\n}\r\n.projectContent > svg:hover{\r\n  color: var(--pearl);\r\n  cursor: pointer;\r\n  \r\n}\r\n\r\n.taskList{\r\n  display: none;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 10px;\r\n  /* width: 100%; */\r\n  /* max-width: 800px; */\r\n\r\n\r\n  margin-bottom: 1rem;\r\n\r\n  user-select: none;\r\n\r\n}\r\n.taskList > div{\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n\r\n  font-size: 1.5rem;\r\n  font-weight: 500;\r\n  \r\n  width: 600px;\r\n  min-height: 50px;\r\n\r\n  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;\r\n  border-radius: 20px;\r\n  padding: 0.5rem 0;\r\n\r\n  cursor: pointer;\r\n\r\n  transition: all 0.1s ease-in;\r\n\r\n\r\n}\r\n\r\n.taskList > div > div p:nth-child(2){\r\n  width: 370px;\r\n  text-wrap: wrap;\r\n}\r\n.taskList > div > div p:nth-child(3){\r\n  width: 100px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  color: var(--prussian);\r\n\r\n  /* justify-self: end; */\r\n  /* width: 400px; */\r\n  text-wrap: nowrap;\r\n  /* padding: 0 0.5px; */\r\n\r\n}\r\n\r\n.taskList > div > div{\r\n  display: flex;\r\n  gap: 5px;\r\n}\r\n.taskList > div > div:nth-child(1){\r\n  width: 85%;\r\n}\r\n\r\n.taskList > div > div:nth-child(1) >div:nth-child(1){\r\n  display: flex;\r\n  align-items: center;\r\n  margin-left: 10px;\r\n\r\n  width: 24px;\r\n  transition: all 0.1s ease-in;\r\n}\r\n.taskList > div > div:nth-child(1) >div:nth-child(1):hover{\r\n  transform: scale(1.3);\r\n}\r\n\r\n.taskList > div > div:nth-child(2){\r\n  width: 80px;\r\n\r\n}\r\n.taskList > div > div:nth-child(2) div:nth-child(1){\r\n  color: var(--prussian);\r\n  transition: all 0.1s ease-in;\r\n}\r\n\r\n.taskList > div > div:nth-child(2) div:nth-child(2){\r\n  color: var(--delete);\r\n\r\n  transition: all 0.1s ease-in;\r\n\r\n}\r\n\r\n.taskList > div > div:nth-child(2) div:hover{\r\n  transform: scale(1.3);\r\n\r\n}\r\n\r\n.taskList >div:not(form):hover{\r\n  filter: brightness(1.3);\r\n  text-shadow: 1px 1px 2px var(--pearl);\r\n}\r\n\r\n\r\n.editTask {\r\n  display: flex;\r\n  justify-content: space-evenly;\r\n  align-items: center;\r\n  flex-direction: row;\r\n\r\n  font-size: 1.5rem;\r\n\r\n  height: 40px;\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n}\r\n.editTask > input:nth-child(1){\r\n  width: 75%;\r\n  /* height: 50px; */\r\n  font-size: 1.5rem;\r\n  text-indent: 0.5rem;\r\n  border-radius: 10px;\r\n  \r\n}\r\n.editTask > button{\r\n  display: flex;\r\n  background-color: transparent;\r\n  border: none;\r\n\r\n}\r\n\r\n\r\n\r\n.projectContent .taskList > form{\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 24px;\r\n\r\n  margin-top: 1rem;\r\n\r\n  animation: popIn 0.1s ease-in;\r\n\r\n  /* border: 1px solid var(--prussian); */\r\n  /* box-shadow: 0 0 5px 1px var(--prussian); */\r\n  box-shadow: inset var(--pearl) 3px 3px 6px 1px, inset var(--prussian) -2px -2px 6px 0px;\r\n  border-radius: 10px;\r\n  padding: 1rem 0.5rem;\r\n\r\n}\r\n@keyframes popIn {\r\n  0% {opacity: 0;}\r\n  100%{ opacity: 1;}\r\n  \r\n}\r\n.projectContent .taskList > form > div:nth-child(1){\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n}\r\n.projectContent .taskList > form > div >input:nth-child(1), .projectContent .taskList > form > div >input:nth-child(2){\r\n  width: 90%;\r\n  align-self: center;\r\n  font-size: 2rem;\r\n  text-indent: 0.5rem;\r\n\r\n  border-radius: 15px;\r\n  padding: 5px 0;\r\n\r\n  background-color: var(--pearl);\r\n\r\n  \r\n}\r\n.projectContent .taskList > form > div:nth-child(1) >input:first-child::placeholder{\r\n  text-align: center;\r\n}\r\n.projectContent .taskList > form > div:nth-child(1) >input:nth-child(2){\r\n  \r\n  text-align: center;\r\n}\r\n\r\n.projectContent .taskList > form > div:nth-child(2){\r\n  display: flex;\r\n  gap: 25px;\r\n  padding: 5px 20px;\r\n\r\n  /* margin-bottom: 3rem; */\r\n}\r\n\r\n.projectContent .taskList >form > div:nth-child(2){\r\n\r\n  border-radius: 10px;\r\n}\r\n\r\n.projectContent .taskList > form button {\r\n  border-radius: 50%;\r\n  border-color: transparent;\r\n  background-color: transparent;\r\n\r\n  cursor: pointer;\r\n  \r\n  \r\n}\r\n/* .projectContent .taskList > form button:nth-child(1) {\r\n  \r\nbox-shadow:  0 0 11px 5px var(--sage), var(--prussian) 3px 3px 6px 5px,  var(--pearl) -2px -2px 6px 8px;\r\nbackground-color: var(--pr);\r\n}\r\n.projectContent .taskList > form button:nth-child(2) {\r\n  box-shadow:  0 0 11px 5px var(--sage), var(--prussian) 3px 3px 6px 5px,  var(--pearl) -2px -2px 6px 8px;\r\n} */\r\n\r\n\r\n\r\n.projectContent .taskList > form button svg{\r\n  height: 50px;\r\n  width: 50px;\r\n}\r\n\r\n.projectContent .taskList > form button:nth-child(1) > svg{\r\n  color: var(--prussian);\r\n}\r\n.projectContent .taskList > form button:nth-child(2) > svg{\r\n  color: var(--pearl);\r\n  \r\n}\r\n\r\n\r\n.priorityRadio{\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n\r\n  align-self: center;\r\n  /* grid-template-areas:  \"title title title\"\r\n                        \"low mid high\"; */\r\n\r\n  width: 90%;\r\n  /* background-color: red; */\r\n}\r\n.priorityRadio h4:nth-child(1){\r\n  /* grid-area: title; */\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  font-size: 2rem;\r\n  font-weight: 500;\r\n\r\n  padding-bottom: 7px;\r\n}\r\n\r\n.priorityRadio > div{\r\n  display: flex;\r\n  border-radius: 50px;\r\n}\r\n.priorityRadio > div > input{\r\n  cursor: pointer;\r\n  height: 40px;\r\n  width: 40px;\r\n  align-self: none;\r\n}\r\n\r\n.priorityRadio > div:nth-child(2){\r\n\r\n  box-shadow:  0 0 11px 5px yellow, var(--prussian) 3px 3px 6px 5px,  var(--pearl) -2px -2px 6px 8px;;\r\n}\r\n\r\n.priorityRadio div:nth-child(3){\r\n  box-shadow:  0 0 11px 5px orange, var(--prussian) 3px 3px 6px 5px,  var(--pearl) -2px -2px 6px 8px;\r\n}\r\n.priorityRadio div:nth-child(4){\r\n  box-shadow:  0 0 11px 5px red ,var(--prussian) 3px 3px 6px 5px,  var(--pearl) -2px -2px 6px 8px;\r\n  \r\n}\r\n\r\n/* ////////////////////////////////////////////////////////////////////////////// */\r\n/* ////////////////////////////////////////////////////////////////////////////// */\r\n@media screen and  (max-width: 600px){\r\n  /* .projectContent{\r\n    padding: 0rem;\r\n  } */\r\n  .new-project div{\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n    gap: 5px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .new-project div:nth-child(5){\r\n    gap: 10px;\r\n\r\n    margin-top: 1rem;\r\n    margin-bottom: 10px;\r\n\r\n    flex-direction: column;\r\n    justify-content: center;  \r\n    align-items: center;\r\n  }\r\n\r\n  .taskList{\r\n    \r\n    max-width: 400px;\r\n    \r\n\r\n  }\r\n  .taskList > div{\r\n    width: 400px;\r\n  }\r\n  .taskList p{\r\n    \r\n    width: 255px;\r\n    text-wrap: wrap;\r\n  \r\n    \r\n  \r\n  }\r\n}\r\n/* ////////////////////////////////////////////////////////////////////////////// */\r\n/* ////////////////////////////////////////////////////////////////////////////// */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
